import { DeleteIcon } from "@chakra-ui/icons";
import { FC } from "react";

import { Schematisation, SchematisationRevision, ThreediModel } from "@nens/threedi/openapi-client";

import ButtonWithConfirmation from "../../components/ButtonWithConfirmation";
import { useDeleteSchematisationRevision } from "../../queries/schematisations";

interface DeleteRevisionButtonProps {
  schematisation: Schematisation;
  revision: SchematisationRevision;
  model: ThreediModel | null;
}

const DeleteRevisionButton: FC<DeleteRevisionButtonProps> = ({
  schematisation,
  revision,
  model,
}) => {
  const deleteSchematisationRevision = useDeleteSchematisationRevision(
    schematisation.id,
    revision.id,
    revision.number
  );

  const disabled = model !== null || !!revision.archived;
  let disabledReason: string | undefined;
  if (revision.archived) {
    disabledReason = "This revision is already archived and cannot be deleted.";
  } else if (model !== null) {
    disabledReason = "It is not possible to delete the revision when the model is still available";
  }

  return (
    <ButtonWithConfirmation
      buttonText="Delete revision"
      dialogTitle="Really delete?"
      confirmationButtonText="Delete"
      confirmationButtonSafety="dangerous"
      onClick={deleteSchematisationRevision}
      disableAfterClick
      disabled={disabled}
      buttonIcon={<DeleteIcon boxSize={5} />}
      marginTop="4"
      customTitle={disabledReason}
      w={"250px"}
    >
      <p>
        This deletes this revision. If it also has a Rana model, this will also be deleted. This
        action cannot be undone.
      </p>
    </ButtonWithConfirmation>
  );
};

export default DeleteRevisionButton;
